"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWorkingHoursSchema = exports.workingHoursEntityTypeEnum = void 0;
const zod_1 = require("zod");
const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
exports.workingHoursEntityTypeEnum = zod_1.z.enum(['BRANCH', 'DEPARTMENT']);
exports.setWorkingHoursSchema = zod_1.z
    .object({
    entityType: exports.workingHoursEntityTypeEnum,
    entityId: zod_1.z.string().uuid(),
    dayOfWeek: zod_1.z.number().int().min(0).max(6),
    openTime: zod_1.z.string().regex(TIME_REGEX).optional(),
    closeTime: zod_1.z.string().regex(TIME_REGEX).optional(),
    isClosed: zod_1.z.boolean().default(false),
})
    .refine((data) => data.isClosed || (data.openTime && data.closeTime), {
    message: 'openTime and closeTime are required unless isClosed is true',
});
//# sourceMappingURL=working-hours.schema.js.map